import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import englishServices from "../SdataEN";
import frenchServices from "../SdataFR";

const ServiceDetails = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const currentServiceState = location.state;

  const [services, setServices] = useState(
    i18n.language === "fr" ? frenchServices : englishServices
  );

  const [currentService, setCurrentService] = useState(() => {
    const initialServices = i18n.language === "fr" ? frenchServices : englishServices;
    return initialServices.find(s => s.detailData.title === currentServiceState.title)?.detailData || currentServiceState;
  });

  // Update services and current service when language changes
  useEffect(() => {
    const selectedServices = i18n.language === "fr" ? frenchServices : englishServices;
    setServices(selectedServices);

    const translatedService = selectedServices.find(
      (s) => s.detailData.title === currentServiceState.title
    );

    if (translatedService) {
      setCurrentService(translatedService.detailData);
    } else {
      setCurrentService(currentServiceState);
    }
  }, [i18n.language, currentServiceState]);

  const handleNavigateToService = (detailData) => {
    navigate("/service-details", {
      state: detailData,
    });
  };

  const otherServices = services.filter(
    (service) => service.detailData.title !== currentService.title
  );

  return (
    <div className="container my-5">
      <div className="d-flex align-items-center justify-content-between flex-wrap">
        <span></span>
        <div className="mt-5 text-center">
          <h5 className="mb-4">{t("service_details_title")}</h5>
          {otherServices.map((service, index) => (
            <button
              key={index}
              className="btn btn-outline-primary m-2"
              onClick={() => handleNavigateToService(service.detailData)}
            >
              {service.title}
            </button>
          ))}
        </div>
      </div>

      <h1 className="mb-3 mt-3">{currentService.title}</h1>
      <h4 className="mb-4 text-muted">{currentService.subtitle}</h4>

      <div className="row">
        {currentService.sections.map((section, index) => (
          <div className="col-md-6 mb-4" key={index}>
            <div className="card p-3 h-100 shadow-sm text-center">
              <div className="text-center mb-2">
                {section.image && (
                  <img
                    src={section.image}
                    alt={`${section.title} icon`}
                    style={{ width: "60px", height: "50px", marginBottom: "10px" }}
                  />
                )}
              </div>
              <h5 className="mb-3">{section.title}</h5>
              <ul className="list-unstyled text-start">
                {section.points.map((point, i) => (
                  <li key={i}>• {point}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceDetails;
